export default __webpack_public_path__ + "static/media/HISTORY_ECONOMICS.ede8d00e.svg";